/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { TicketEventStatus } from './TicketEventStatus';
import {
    TicketEventStatusFromJSON,
    TicketEventStatusFromJSONTyped,
    TicketEventStatusToJSON,
    TicketEventStatusToJSONTyped,
} from './TicketEventStatus';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpsertTicketEventRequest
 */
export interface UpsertTicketEventRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertTicketEventRequest
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertTicketEventRequest
     */
    startsAtLocal: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertTicketEventRequest
     */
    venue: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertTicketEventRequest
     */
    description: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpsertTicketEventRequest
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertTicketEventRequest
     */
    price: number;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpsertTicketEventRequest
     */
    capacity: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpsertTicketEventRequest
     */
    maxPerOrder: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {TicketEventStatus}
     * @memberof UpsertTicketEventRequest
     */
    status: TicketEventStatus;
    /**
     * 
     * @type {string}
     * @memberof UpsertTicketEventRequest
     */
    salesEndLocal: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpsertTicketEventRequest
     */
    quantityDealPayFor?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpsertTicketEventRequest
     */
    quantityDealReceive?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertTicketEventRequest
     */
    promoCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertTicketEventRequest
     */
    promoDiscountKind?: string | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof UpsertTicketEventRequest
     */
    promoDiscountValue?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertTicketEventRequest
     */
    locationName?: string | null;
}



/**
 * Check if a given object implements the UpsertTicketEventRequest interface.
 */
export function instanceOfUpsertTicketEventRequest(value: object): value is UpsertTicketEventRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('startsAtLocal' in value) || value['startsAtLocal'] === undefined) return false;
    if (!('venue' in value) || value['venue'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('capacity' in value) || value['capacity'] === undefined) return false;
    if (!('maxPerOrder' in value) || value['maxPerOrder'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('salesEndLocal' in value) || value['salesEndLocal'] === undefined) return false;
    return true;
}

export function UpsertTicketEventRequestFromJSON(json: any): UpsertTicketEventRequest {
    return UpsertTicketEventRequestFromJSONTyped(json, false);
}

export function UpsertTicketEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertTicketEventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'startsAtLocal': json['startsAtLocal'],
        'venue': json['venue'],
        'description': json['description'],
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'price': json['price'],
        'capacity': ApiUserTasksGetPageParameterFromJSON(json['capacity']),
        'maxPerOrder': ApiUserTasksGetPageParameterFromJSON(json['maxPerOrder']),
        'status': TicketEventStatusFromJSON(json['status']),
        'salesEndLocal': json['salesEndLocal'],
        'quantityDealPayFor': json['quantityDealPayFor'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['quantityDealPayFor']),
        'quantityDealReceive': json['quantityDealReceive'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['quantityDealReceive']),
        'promoCode': json['promoCode'] == null ? undefined : json['promoCode'],
        'promoDiscountKind': json['promoDiscountKind'] == null ? undefined : json['promoDiscountKind'],
        'promoDiscountValue': json['promoDiscountValue'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['promoDiscountValue']),
        'locationName': json['locationName'] == null ? undefined : json['locationName'],
    };
}

export function UpsertTicketEventRequestToJSON(json: any): UpsertTicketEventRequest {
    return UpsertTicketEventRequestToJSONTyped(json, false);
}

export function UpsertTicketEventRequestToJSONTyped(value?: UpsertTicketEventRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'startsAtLocal': value['startsAtLocal'],
        'venue': value['venue'],
        'description': value['description'],
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'price': value['price'],
        'capacity': ApiUserTasksGetPageParameterToJSON(value['capacity']),
        'maxPerOrder': ApiUserTasksGetPageParameterToJSON(value['maxPerOrder']),
        'status': TicketEventStatusToJSON(value['status']),
        'salesEndLocal': value['salesEndLocal'],
        'quantityDealPayFor': ActorActivityRecordActorUserIdToJSON(value['quantityDealPayFor']),
        'quantityDealReceive': ActorActivityRecordActorUserIdToJSON(value['quantityDealReceive']),
        'promoCode': value['promoCode'],
        'promoDiscountKind': value['promoDiscountKind'],
        'promoDiscountValue': BalanceUnitStatementEntryDebitToJSON(value['promoDiscountValue']),
        'locationName': value['locationName'],
    };
}

